<template>
  <v-card class="my-12" max-width="400">
    <v-card-title>
      <div>
        {{ job.title }} <br />
        <div class="text-subtitle-1">{{ job.location }}</div>
      </div>
    </v-card-title>
    <v-card-text>
      <v-chip-group column>
        <v-chip disabled>{{ job.employment_type }}</v-chip>

        <v-chip disabled>{{ job.wage_type }}</v-chip>

        <v-chip v-for="(item, key) in job.extras" :key="key" disabled>
          {{ item }}
        </v-chip>
      </v-chip-group>
    </v-card-text>
    <v-card-text>
      <div class="text-subtitle-1">
        {{ job.description }}
      </div>
    </v-card-text>

    <v-divider class="mx-4"></v-divider>

    <v-card-title>Posted by:</v-card-title>
    <v-list-item class="grow" v-if="job.author">
      <v-list-item-avatar color="grey darken-3">
        <v-img
          class="elevation-6"
          alt=""
          :src="
            job.author.company.avatar.thumb_url ||
              require('@/assets/images/default-profile.png')
          "
        ></v-img>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title>
          {{ job.author.company.name }}
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <br />
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn v-if="!job.disabled_at" color="primary" @click="disable(job.id)">
        <span v-if="!loading">Disable job post</span>
        <v-progress-circular
          v-else
          :width="3"
          :size="25"
          color=""
          indeterminate
        ></v-progress-circular>
      </v-btn>

      <v-btn v-else :disabled="true">Job disabled</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  props: {
    job: {
      type: Object,
      default: Object
    }
  },
  data: () => ({
    loading: false
  }),
  methods: {
    /**
     * Get the disable function from reported-job.js
     */
    ...mapActions({
      disableJob: 'reportedJob/disableJob'
    }),

    /**
     * Disable job
     * @param {BigInteger} jobId
     */
    disable(jobId) {
      this.loading = true
      this.disableJob(jobId).then(() => {
        this.$router.push({ name: 'reported-jobs' })
      })
    }
  }
}
</script>

<style scoped>
.v-chip {
  color: rgba(0, 0, 0, 0.6);
  opacity: 1;
}
</style>
